import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, useId, useState, } from 'react';
import classNames from 'classnames';
import { CheckIcon, HelperText } from '../../components';
import { ValidationStates } from '../../enums';
import styles from './RadioButtonGroup.module.scss';
const RadioButtonGroup = ({ a11yLegendText, children, className, hasRequiredMarker = false, helperText, label, name, onChange = () => null, validationState, value, vertical = false, }) => {
    const isSuccess = validationState === ValidationStates.Success;
    const helperId = useId();
    const [selected, setSelected] = useState(value);
    const [prevValue, setPrevValue] = useState(value);
    if (value !== prevValue) {
        setPrevValue(value);
        setSelected(value);
    }
    const handleOnChange = (newValue, event) => {
        if (newValue !== selected) {
            setSelected(newValue);
            onChange(newValue, event);
        }
    };
    const getRadioButtons = () => {
        const mappedChildren = Children.map(children, radioButton => {
            const { className: radioButtonClass, value: radioButtonVal } = (radioButton?.props ?? undefined);
            const newProps = {
                id: `${name}-${radioButtonVal}`,
                name,
                key: radioButtonVal,
                value: radioButtonVal,
                onChange: handleOnChange,
                checked: radioButtonVal === selected,
                validationState,
                classNames: {
                    wrapperClassName: classNames(radioButtonClass, vertical ? styles.verticalGroup : styles.horizontalGroup),
                },
            };
            return cloneElement(radioButton, newProps);
        });
        return mappedChildren;
    };
    return (_jsxs("div", { id: name, role: "radiogroup", className: classNames('theme-text-body-highlight', className), children: [label && (_jsxs("div", { className: "mb-2x", children: [label, hasRequiredMarker && '*'] })), _jsxs("fieldset", { className: classNames('d-flex m-0 p-0', {
                    'flex-column align-items-start': vertical,
                    'align-items-center': !vertical,
                }), "aria-describedby": helperText ? helperId : undefined, children: [_jsx("legend", { className: "screenReaderOnly", children: a11yLegendText }), getRadioButtons(), isSuccess && _jsx(CheckIcon, { className: styles.successIndicator })] }), helperText && (_jsx(HelperText, { id: helperId, className: vertical ? 'mt-2x' : 'mt-1x', validationState: validationState, children: helperText }))] }));
};
export { RadioButtonGroup };
